import {
  LEGAL_DOC_URL,
  LegalDocumentFileResponse,
  LegalDocumentsResponse,
  OyResponse,
} from '@oy/types';
import axios from 'src/clients/axios';

export const getLegalDocuments = () => {
  return axios.get<LegalDocumentsResponse>(LEGAL_DOC_URL, {
    onlyProduction: true,
    disableToast: true,
  });
};

export const getLegalDocumentById = (documentId: string) => {
  return axios.get<LegalDocumentFileResponse>(
    `${LEGAL_DOC_URL}/${documentId}`,
    { onlyProduction: true },
  );
};

export const signLegalDocument = (documents: string[]) => {
  return axios.put<OyResponse<null>>(
    `${LEGAL_DOC_URL}/sign`,
    {
      documents,
    },
    { onlyProduction: true },
  );
};
